import type { FC } from "react";

import { PushBlockTextSection } from "../PushBlock/components";

import styles from "./CtaBlock.module.scss";

export type CtaBlockProps = {
  title: string;
  text: string;
  href: string;
  ctaText: string;
};

export const CtaBlock: FC<CtaBlockProps> = ({ title, ctaText, text, href }) => {
  return (
    <div className={styles.wrapper}>
      <PushBlockTextSection
        title={title}
        text={text}
        containedCTA={true}
        cta={ctaText}
        href={href}
        isCentered={false}
        secondButton={{}}
      />
    </div>
  );
};
